var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.80234 14.9728C4.92557 14.7916 3.09592 13.8639 1.88286 12.4785C0.110039 10.4538 -0.459697 7.6641 0.382501 5.13188C0.790604 3.90492 1.57806 2.70872 2.52146 1.88286C4.54622 0.110039 7.3359 -0.459697 9.86812 0.382501C11.0951 0.790604 12.2913 1.57806 13.1171 2.52146C14.89 4.54622 15.4597 7.3359 14.6175 9.86812C14.2094 11.0951 13.4219 12.2913 12.4785 13.1171C10.9154 14.4858 8.82758 15.1683 6.80234 14.9728ZM9.30053 8.14514L12.2556 5.18954L10.9034 3.84304L6.36447 8.37961L5.25881 7.27438C4.65067 6.66654 4.13547 6.16915 4.11382 6.16915C4.09217 6.16915 3.76662 6.47741 3.39022 6.85422L2.70598 7.53928L4.48644 9.32006C5.46565 10.2995 6.28459 11.1008 6.30626 11.1008C6.32793 11.1008 7.67519 9.77067 9.30053 8.14514Z",
    fill: "#9898AE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/checkGrey.0ea497a5d7100ef5015928104838e560.svg";
export { ForwardRef as ReactComponent };